import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorsComponent } from './errors/errors.component';
import { NotFoundComponent } from './not-found/not-found.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./index/index.module').then(m => m.IndexModule) },
  {
    path: 'error',
    component: ErrorsComponent
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: { title: 'Page Not Found' }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: false, enableTracing: false, onSameUrlNavigation: 'reload' }),
  ],
  exports: [RouterModule],
})

export class PublicRoutingModule { }
